import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { contractPageSearchSchema } from '&/features/leasing/contracts/lib/contracts-list-search';
import { CONTRACTS_LIST_PERMISSION, LEASING_PATH } from '&/features/leasing/paths';

// SWOOP-345 / SWOOP-365. The trailing underscore un-nests it from `contracts.tsx`, which has no <Outlet/>
// (precedent: `contracts_.new.tsx`). The parent `/leasing` route applies the module switch and
// `leasing:access`; this one adds `contracts:list`. On a hard refresh permissions may not be loaded yet, so
// `beforeLoad` lets that through and the page re-checks reactively. It carries the list's search schema so
// the Back link can return to `/leasing/contracts` with its search / status / page intact (SWOOP-365), plus the
// `tab` to open, so the agreement page's Back returns to the Agreements tab.
export const Route = createFileRoute('/_authenticated/leasing/contracts_/$contractId')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission(CONTRACTS_LIST_PERMISSION)) {
      throw redirect({ to: LEASING_PATH });
    }
  },
  component: lazyRouteComponent(() => import('&/features/leasing/contracts/pages/contract-page'), 'ContractPage'),
  staticData: { dynamic: true },
  validateSearch: (search) => contractPageSearchSchema.parse(search),
});
